export default __webpack_public_path__ + "static/media/image15.3e39035e.jpg";